import React from "react";
import { motion } from "framer-motion";

// Masked line-by-line reveal for headings
const wordContainer = {
  hidden: {},
  show: (stagger = 0.05) => ({ transition: { staggerChildren: stagger } }),
};
const wordChild = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export function RevealText({ text, className = "", delay = 0, as: Tag = "span" }) {
  const words = text.split(" ");
  const MotionTag = motion[Tag] || motion.span;
  return (
    <MotionTag
      className={className}
      variants={wordContainer}
      custom={0.05}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-10%" }}
      transition={{ delayChildren: delay }}
    >
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom">
          <motion.span className="inline-block" variants={wordChild}>
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}

// Fade + rise on scroll into view
export function Reveal({ children, className = "", delay = 0, y = 32 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
